import styles from './styles.module.css';
import Image from '@/shared/components/Image/new';

const AperturaSinFoto = (props) => {

    const MAIN_CROP = '3_2_630x420';
    const SECONDARY_CROP = '1_1_630x600';

    const {
        hasBackground,
        isMainWidget = false
    } = { ...props };
    let mainContent = [...props.content] || [];
    const highlightedContent = mainContent.length > 0 ? [mainContent.shift()] : undefined;
    const firstColumnContent = mainContent.length >= 1 ? mainContent.splice(0, 1) : [];
    const thirdContent = mainContent.length >= 2 ? mainContent.splice(0, 2) : mainContent.length >= 1 ? mainContent.splice(0, 1) : [];
    const bucketContent = mainContent;

    const getAuthors = (authors) => {
        let authorsList = []
        if (authors != undefined && authors?.length) {
            authors.length > 1 ? authors.slice(0, 2).map(element => authorsList.push(element.slug ? `<a href=/autor/${element.slug}>${element.name}</a>` : element.name)) : authorsList.push(authors[0].slug ? `<a href=/autor/${authors[0].slug}>${authors[0].name}</a>` : authors[0].name)
        }
        const parsedAuthors = authorsList.join(' y ');
        return parsedAuthors
    }

    return (
        <div className={` ${styles["listado-parent"]} ${styles[hasBackground ? 'dark-theme' : '']}`}>
            <div className={` ${styles["middle-block"]}`}>
                {highlightedContent && highlightedContent.map((element, index) => {
                    const { url, title, authors, summary } = element;
                    const authorElement = getAuthors(authors);

                    return (
                        <div className={` ${styles["main-container"]}`} key={element._id + index}>
                            <div>
                                <a href={url}>
                                    <h1>{title}</h1>
                                    <div dangerouslySetInnerHTML={{ __html: summary}}></div>
                                </a>
                                {authorElement && (
                                    <h5
                                        className={`${styles['author']}`}
                                        dangerouslySetInnerHTML={{
                                            __html: 'Por ' + authorElement
                                        }}
                                    />
                                )}
                            </div>

                            <ul data-testid='buckets'>
                                {bucketContent && bucketContent.map((el, index) => {
                                    const { url, title, subtitle } = el;
                                    return (
                                        <li key={`bucket-${index}`} className={`${styles['buckets']}`}>
                                            <a href={url}>
                                                <h3>{subtitle && <span className={`${styles['highlighted']}`}>{subtitle}: </span>}<span>{title}</span></h3>
                                            </a>
                                        </li>
                                    )
                                })}
                            </ul>
                        </div>
                    );
                })}
            </div>
            <div className={` ${styles["first-block"]}`}>
                {firstColumnContent && firstColumnContent.map((element, index) => {
                    const { url, title, subtitle } = element;
                    let elementImages = {
                        images: [
                            element.images[0] && element.images[0].value &&
                            {
                                clippings: element.images[0].value.clippings ? element.images[0].value.clippings : [],
                                title: element.images[0].value.title ? element.images[0].value.title : ''
                            }
                        ]
                    };
                    
                    return (
                        <div className={` ${styles["main-container"]}`} key={element._id + index}>
                            <a href={url}>
                                <Image
                                    element={elementImages}
                                    clipping={MAIN_CROP}
                                    width={630}
                                    height={420}
                                    srcSet={{
                                        mobile: MAIN_CROP
                                    }}
                                    className={styles["img"]}
                                />
                            </a>
                            <div>
                                <a href={url}><h2><span className={`${styles['subtitle']}`}>{subtitle} </span>{title}</h2></a>
                            </div>
                        </div>
                    );
                })}
            </div>
            
            <div className={` ${styles["third-block"]}`}>
                {thirdContent && thirdContent.map((element, index) => {
                    const { url, title, authors } = element;
                    let elementImages = {
                        images: [
                            element.images[0] && element.images[0].value &&
                            {
                                clippings: element.images[0].value.clippings ? element.images[0].value.clippings : [],
                                title: element.images[0].value.title ? element.images[0].value.title : ''
                            }
                        ]
                    };

                    return (
                        <div className={`${styles["third-horizontal"]}`} key={element._id + index}>
                            <div className={`${styles["title-desc"]}`}>
                                <a href={url}><h4>{title}</h4></a>
                            </div>
                            <div className={`${styles["image-content"]}`}>
                                <a href={url}>
                                    <Image
                                        element={elementImages}
                                        clipping={SECONDARY_CROP}
                                        width={630}
                                        height={600}
                                        srcSet={{
                                            mobile: SECONDARY_CROP
                                        }}
                                        className={styles["img"]}
                                    />
                                </a>
                            </div>
                        </div>
                    );
                })}
            </div>
        </div>
    )
}

export default AperturaSinFoto;